import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TaskProgressNode } from 'src/app/dto';

// Thin leaf that delegates straight into the existing, unmodified quest-task-renderer
// registry — connects the node-renderer and quest-task-renderer registries, doesn't merge them.
@Component({
    selector: 'app-task-progress-node',
    templateUrl: './task-progress-node.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskProgressNodeComponent {
    @Input() node: TaskProgressNode;
}
